module.exports = __webpack_public_path__ + "images/9d1e54be7b61ac95f492db68965c8f48.png";